import { getElementOffset } from "./_utils";

export default class AdfCollection
{
    constructor ()
    {
        this.bindEvents();

        if ( window.location.hash )
        {
            this.onChangeSection( window.location.hash );
        }
    }

    bindEvents ()
    {
        this.selCollectionSection = document.querySelector( "#collection-section" );

        this.selCollectionSection.addEventListener( "change", ( e ) => this.onChangeSection( e.target.value ) )

        this.sections = Array.from( document.querySelectorAll( "[data-slug]" ) );

        this.btnPrev = document.querySelector( "#btn-prev" );
        this.btnNext = document.querySelector( "#btn-next" );


        this.btnPrev.addEventListener( "click", ( e ) => this.onPrev( e ) )
        this.btnNext.addEventListener( "click", ( e ) => this.onNext( e ) )

        window.onhashchange = (e) => this.onChangeSection( window.location.hash );

    }


    onPrev ( e )
    {
        e.preventDefault();

        let select   = document.querySelector( "#collection-section" );
        let options  = select.options;
        let values   = Array.from( options ).map( o => o.value );
        let selected = options[ select.selectedIndex ].value;

        let index = values.findIndex( v => v === selected );

        if ( index > 0 )
        {
            let newValue = values[ index - 1 ];
            select.value = newValue;

            this.onChangeSection( newValue )

        }

    }

    onNext ( e )
    {
        e.preventDefault();

        let select   = document.querySelector( "#collection-section" );
        let options  = select.options;
        let values   = Array.from( options ).map( o => o.value );
        let selected = options[ select.selectedIndex ].value;

        let index = values.findIndex( v => v === selected );

        if ( index < (values.length - 1) )
        {
            let newValue = values[ index + 1 ];
            select.value = newValue;

            this.onChangeSection( newValue )

        }


    }


    onChangeSection ( slug )
    {

        let hashlessSlug = slug.replace( '#', '' );
        let newSection   = document.querySelector( `[data-slug='${hashlessSlug}']` );


        //
        // 20230216 :   MB : removing this because we still need to figure out the active index
        //              and adjust the prev/next buttons on first load

        // if ( !newSection )
        // {
        //     return;
        // }


        this.sections.forEach( section =>
        {

            if ( !section.classList.contains( "d-none" ) )
            {
                section.classList.add( "d-none" )
            }
        } )


        newSection.classList.remove( "d-none" );

        window.location.hash = slug;





        let select  = document.querySelector( "#collection-section" );
        let options = select.options;
        let values  = Array.from( options ).map( o => o.value );

        let index = values.indexOf( hashlessSlug );

        const btnCurrentPage     = document.querySelector( "#current-page" );
        btnCurrentPage.innerText = index + 1;
        btnCurrentPage.setAttribute( 'aria-label', 'Page ' + (index + 1) );


        /**
         * It wasn't setting the proper choice when arriving to the page
         * with a specific section pre-selected (hash)
         */
        if ( select.value !== hashlessSlug )
        {
            select.value = hashlessSlug;
        }

        if ( index === 0 )
        {
            this.btnPrev.setAttribute( 'disabled', true );
        } else
        {
            this.btnPrev.removeAttribute( 'disabled' );
        }

        if ( index === (options.length - 1) )
        {
            this.btnNext.setAttribute( 'disabled', true );
        } else
        {
            this.btnNext.removeAttribute( 'disabled' );
        }


        select.focus();

        window.scrollTo( {
            top      : 50,
            left     : 0,
            behavior : 'smooth',
        } );
    }


    prevNext ( e )
    {
        e.preventDefault();


    }

    updateURL ()
    {
        if ( 'URLSearchParams' in window )
        {
            var searchParams = new URLSearchParams( window.location.search );
            searchParams.set( "s", strSearchTerms.value );

            var strNewPath = window.location.pathname + '?' + searchParams.toString();
            history.pushState( null, '', strNewPath );
        }
    }

}
